import zhCN from 'antd/locale/zh_CN'
import zhHK from 'antd/locale/zh_HK'
import enUS from 'antd/locale/en_US'
import type { Locale } from 'antd/es/locale'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-hk'

import type { SupportedLanguage } from './config'

export const ANTD_LOCALES: Record<SupportedLanguage, Locale> = {
  'zh-CN': zhCN,
  'zh-HK': zhHK,
  en: enUS,
}

export const DAYJS_LOCALES: Record<SupportedLanguage, string> = {
  'zh-CN': 'zh-cn',
  'zh-HK': 'zh-hk',
  en: 'en',
}

export const syncDayjsLocale = (language: SupportedLanguage): void => {
  dayjs.locale(DAYJS_LOCALES[language] || DAYJS_LOCALES['zh-CN'])
}
